<template>
  <el-form ref="formOption"  label-width="100px">
    <el-row>
      <el-col :span="22" :offset="1">
        <el-form-item label="题目：">
            <div v-if="IsTitle">
              <Editor placeholder="请输入内容"/>
            </div>
            <div v-else>
              <span class="yk-multiselect-question" v-html="data.Content"></span>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-if="filesList.length > 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="题目附件：">
            <div v-if="IsTitle">
              <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false" />
            </div>
            <div v-else>
              <QuestionFile ref="fileList" :url="urlAliyunOSS" :fileIds.sync="fileIds" :filesList="filesList" :files.sync="fileList" :IsUpload="false"/>
            </div>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row>
      <el-col :span="22" :offset="1" v-show="IsAnswers != 0">
        <el-form-item label="答案：">
          <Editor v-if="IsAnswers > 0" placeholder="请输入内容" v-model="content[0]" :config="config"/>
          <span v-else v-for="item in data.Answers" :key="item" v-html="item"></span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="IsAnalysis != 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="解析：">
            <Editor v-if="IsAnalysis > 0" placeholder="请输入内容" />
            <span v-else v-html="data.Analysis"></span>
        </el-form-item>
      </el-col>
    </el-row>
    <el-row v-show="IsAnalysis != 0 && analysisFilesList.length > 0">
      <el-col :span="22" :offset="1">
        <el-form-item label="解析附件：">
            <QuestionFile ref="analysisFileList" :url="urlAliyunOSS" :fileIds.sync="analysisFileIds" :filesList="analysisFilesList" :files.sync="analysisFileList" :IsUpload="false"/>
        </el-form-item>
      </el-col>
    </el-row>
  </el-form>
</template>

<script>
// import Vue from 'vue';
import QuestionFile from 'components/AliyunOSS/QuestionBankFile.vue';

export default {
  name: 'short-answer',
  components: {
    QuestionFile
  },
  props: {
    IsTitle: {
      type: Boolean,
      default: true
    },
    IsSelects: {
      type: Boolean,
      default: true
    },
    IsAnswers: {
      type: Number,
      default: 0
    },
    IsAnalysis: {
      type: Number,
      default: 0
    },
    data: {
      type: Object,
      default: function() {
        return {};
      }
    }
  },
  data() {
    return {
      urlAliyunOSS: '/api/design/osssign/getsign',
      // 题干附件
      fileList: [],
      fileIds: [], // 附件Id
      filesList: [],
      // 解析附件
      analysisFileList: [],
      analysisFileIds: [],
      analysisFilesList: [],
      content: [],
      formOption: {
        choice: null
      },
      config: {
        events: {
          'froalaEditor.contentChanged': () => {
            this.doCheckValue();
          }
        }
      }
    };
  },
  created() {
    if (this.data.Answers) {
      this.content = this.data.Answers;
    }
    this.filesList = this.data.stemFiles;
    this.analysisFilesList = this.data.analysisFiles;
  },
  methods: {
    // 做作业是选择答案
    doCheckValue: function() {
      this.$emit('getAnswer', {
        Id: this.data.Id,
        Answers: this.content
      });
    }
  }
};
</script>
<style lang="scss">

.yk-multiselect-question{
    p{
      margin:0;
      padding:0;
    }
  }
</style>
